import React from 'react';
import { Layout, Row, Col } from 'antd';
import { withRouter } from 'react-router-dom';

import BadgeIos from '../../resources/img/badge_ios.svg';
import Logo from '../../resources/img/tou_title.png';
import ToU_BG from '../../resources/img/tou.png';
import Left from '../../resources/img/left.png';
import Button from '../components/Button';
import Footer from '../components/Footer';

const { Header, Content } = Layout;


class ToU extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }

    render() {
        return (
            <Layout className={'fadeIn full-layout tou'}>
                <div className={'tou__bg-box'}>
                    <img src={ToU_BG} alt="" className={'tou__bg'}/>
                </div>
                <Header className={'header work-header'}>
                    <div className={'work-header__title'}>
                        <Button icon={Left} className={'work-header__back'} onClick={() => this.props.history.push('/')}/>
                        <img className={'work-header__title__img'} src={Logo} alt="logo"/>
                    </div>
                </Header>
                <Content className={'tou__content-box'}>
                    <div className={'tou__content tou__content--center'}>
                        <Row justify={'center'} align={'middle'}>
                            <Col lg={7} sm={8} xs={24}>
                                <div className={'tou__download-box'}>
                                    <a target={'blank'} href="https://apps.apple.com/us/app/task-of-universe/id1526806719?mt=8">
                                        <img className={'tou__download-icon cube-fit__download-icon--ios'} alt='Download on the App Store' src={BadgeIos}/>
                                    </a>
                                </div>
                            </Col>
                            <Col lg={7} sm={8} xs={24}>
                                <div className={'tou__download-box'}>
                                    <a target={'blank'} href='https://play.google.com/store/apps/details?id=com.Dev09.TaskofUniverse'>
                                        <img className={'tou__download-icon'} alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Content>
                <Footer/>
            </Layout>
        );
    }
}

export default withRouter(ToU);